import moment from 'moment';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { generateHeader } from 'lib/pdfs/Common';
import { formatTimeStamp, formatDate } from 'lib/util';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

export const generateHistoricsPDF = async (
  subcompany,
  records,
  filters,
  accounts,
  costCenters,
  employees,
  status,
  locations = []
) => {
  console.log('Subcompany:', subcompany);
  console.log('Records:', records);
  console.log('Filters:', filters);
  console.log('Accounts:', accounts);
  console.log('Cost Centers:', costCenters);
  console.log('Employees:', employees);
  console.log('Status:', status);
  console.log('Locations:', locations);

  const header = await generateHeader(`${subcompany.name} \nHistorial de Activos`);

  const tableBody = records.map((record, difference) => [
    { text: record.status || '', fontSize: 8 },
    { text: record.createdAt ? moment(record.createdAt).format('DD/MM/YYYY') : '', fontSize: 8 },
    { text: record.reviewDate ? moment(record.reviewDate).format('DD/MM/YYYY') : '', fontSize: 8 },
    { text: record._createdBy ? `${record._createdBy.name} ${record._createdBy.lastname}` : 'Sistema', fontSize: 8 },
    { text: record._reviewedBy ? `${record._reviewedBy.name} ${record._reviewedBy.lastname}` : 'Sistema', fontSize: 8 },
    { text: record._asset.number ? record._asset.number : '', fontSize: 8 },
    { text: record._asset.name ? record._asset.name : '', fontSize: 8 },
    { text: record._asset._employee ? `${record._asset._employee.name} ${record._asset._employee.lastname}` : 'Sin empleado asignado', fontSize: 8 },
    { text: record._asset && record._asset._employee ? (record._asset.validated && !record.sinEmployee ? 'Validado' : 'Por Validar') : 'Por Validar', fontSize: 8 },
  ]);

  const docDefinition = {
    pageOrientation: 'landscape',
    content: [
      header,
      {
        margin: [0, 30, 0, 0],
        table: {
          headerRows: 0,
          widths: ['*', 500, '*'],
          body: [
            [
              { text: 'Filtros:', border: [false, false, true, true] },
              { text: '', border: [false, false, true, true] },
              {
                text: `Fecha: ${moment().format('DD/MM/YYYY')}`,
                border: [false, false, true, true],
              },
            ],
          ],
        },
      },
      {
        margin: [0, 0, 0, 0],
        table: {
          headerRows: 0,
          widths: ['*', 400, '*'],
          body: [
            [
              {
                text: `Estatus: ${filters.status || 'Todos'}`,
                border: [false, false, false, false],
              },
              {
                text: `Fecha Solicitud: ${formatDate(filters.createdAtStart)} - ${formatDate(
                  filters.createdAtEnd
                )}`,
                border: [false, false, false, false],
              },
              {
                text: `Fecha Aceptacion: ${formatDate(filters.reviewDateStart)} - ${formatDate(
                  filters.reviewDateEnd
                )}`,
                border: [false, false, false, false],
              },
            ],
            [
              {
                text: `Busqueda: ${filters.fulltext || 'Todos'}`,
                border: [false, false, false, false],
              },
              {
                text: `Cuentas: ${filters.accounts || 'Todos'}`,
                border: [false, false, false, false],
              },
              {
                text: `Centros de costos: ${filters.costCenters || 'Todos'}`,
                border: [false, false, false, false],
              },
            ],
            [
              {
                text: `Empleados: ${filters.employees || 'Todos'}`,
                border: [false, false, false, false],
              },
              { text: '', border: [false, false, false, false] },
              { text: '', border: [false, false, false, false] },
            ],
          ],
        },
      },
      {
        margin: [0, 10, 0, 0],
        table: {
          headerRows: 0,
          widths: ['*'],
          body: [[{ text: 'Campos seleccionados:', border: [false, false, false, true] }]],
        },
      },
      {
        margin: [0, 0, 0, 0],
        table: {
          widths: ['*', '*', '*', '*', '*', '*', '*', '*', '*'],
          body: [
            [
              { text: 'Status', bold: true, fontSize: 10, alignment: 'center'},
              { text: 'Solicitud', bold: true, fontSize: 10, alignment: 'center' },
              { text: 'Revisado', bold: true, fontSize: 10, alignment: 'center' },
              { text: 'Responsable', bold: true, fontSize: 10, alignment: 'center' },
              { text: 'Revisado por', bold: true, fontSize: 10, alignment: 'center' },
              { text: 'Clave', bold: true, fontSize: 10, alignment: 'center' },
              { text: 'Activo', bold: true, fontSize: 10, alignment: 'center' },
              { text: 'Empleado', bold: true, fontSize: 10, alignment: 'center' },
              { text: 'Validado', bold: true, fontSize: 10, alignment: 'center' },
            ],
            ...tableBody,
          ],
        },
      },
    ],
  };

  pdfMake.createPdf(docDefinition).open();
};



// WEBPACK FOOTER //
// src/lib/pdfs/HistoricsPDF.js